// extracted by mini-css-extract-plugin
export default {"lostItemsForm":"lostItemsForm---puRMt","resetButton":"resetButton---AJ_n9"};